import '@nicheaim/nicheaim-timetracking-webcomponent/tracker';
import type { NicheAimTimeTrackingElement } from '@nicheaim/nicheaim-timetracking-webcomponent/tracker';
import { Box } from '@mui/material';
import { useRef } from 'react';
import { useNicheAimElement } from 'src/components/nicheaim-time-tracking/useNicheAimElement';

const configureRecorder = (timer: NicheAimTimeTrackingElement) => {
  timer.references = [];
  timer.referenceFields = [];
  timer.referenceValueHidden = true;
  timer.extraMetadata = [];
};

export default function NicheAimTimeTrackingWidget() {
  const timerRef = useRef<NicheAimTimeTrackingElement>(null);
  const { enabled } = useNicheAimElement(timerRef, configureRecorder);
  if (!enabled) return null;
  return (
    <Box
      aria-label="NicheAim time tracker"
      sx={{
        position: 'fixed',
        right: { xs: 16, sm: 32 },
        bottom: { xs: 16, sm: 32 },
        maxWidth: 'calc(100vw - 32px)',
        zIndex: (theme) => theme.zIndex.speedDial,
      }}
    >
      <nicheaim-time-tracker ref={timerRef} container />
    </Box>
  );
}
